import { EmployeeSelect, type EmployeeSelectProps } from '@/components/selects/EmployeeSelect';
import { useSelectLabels } from '@/hooks/useSelectLabels';

export type ManagerSelectProps = Omit<EmployeeSelectProps, 'allowClear' | 'clearLabel'> & {
  /** Employee who must not be selectable as their own manager. */
  forEmployeeId?: number;
  /** When true, manager cannot be cleared (required field). */
  required?: boolean;
  allowClear?: boolean;
  clearLabel?: string;
};

/** Manager picker with self-exclusion; optional clear to remove reporting lines when not required. */
export function ManagerSelect({
  forEmployeeId,
  excludeEmployeeIds,
  label = 'Manager',
  placeholder,
  clearLabel,
  required,
  allowClear,
  ...props
}: ManagerSelectProps) {
  const selectLabels = useSelectLabels();
  const excluded = [
    ...(forEmployeeId != null ? [forEmployeeId] : []),
    ...(excludeEmployeeIds ?? []),
  ];
  const canClear = required ? false : allowClear ?? true;

  return (
    <EmployeeSelect
      label={required ? `${label} *` : label}
      placeholder={placeholder ?? selectLabels.selectManager}
      allowClear={canClear}
      clearLabel={clearLabel ?? selectLabels.noManager}
      required={required}
      excludeEmployeeIds={excluded.length > 0 ? excluded : undefined}
      {...props}
    />
  );
}
